import { t } from 'i18next';
import * as yup from 'yup';

export const createVendorOrderFromQuoteSchema = () =>
  yup.object({
    agreeTermsAndConditions: yup.boolean().label(t('labelAgreeTermsAndConditions')).nullable(),
  });
